import React, { Component } from "react";
import { Helmet } from "react-helmet";
import logo from "./images/logoFull.png";
import Geosuggest from "react-geosuggest";
import Select from "react-select";

import "firebase/compat/firestore";
import "firebase/compat/storage";
import "firebase/compat/auth";
import "firebase/compat/functions";
import { withTranslation } from "react-i18next";
import firebase from "firebase/compat/app";

class RegBar extends Component {
  constructor(props) {
    super(props);

    this.state = {
      location: "",
      address: "",
      title: "",
      number: "",
      selectedCat: [],
      errorText: "",
    };
    if (firebase.auth().currentUser == null) {
      this.props.history.push("/login");
    }
  }

  getLocation(suggest) {
    if (suggest != undefined) {
      this.setState({
        location: suggest.location,
        address: suggest.label,
      });
    }
  }

  addBar() {
    if (
      this.state.location !== "" &&
      this.state.address !== "" &&
      this.state.title !== "" &&
      this.state.number !== ""
    ) {
      console.log("IN===>");
      let categories = [];
      this.state.selectedCat.forEach((cat) => {
        categories = [...categories, cat.value];
      });
      const uid = firebase.auth().currentUser.uid;
      let ref = firebase
        .firestore()
        .collection("bars")
        .doc(uid + "1");
      ref.set({
        adress: this.state.address,
        category: categories,
        coordinates: {
          latitude: this.state.location.lat,
          longitude: this.state.location.lng,
        },
        events: [],
        hours: {
          monday: "00:00-00:00",
          tuesday: "00:00-00:00",
          wednesday: "00:00-00:00",
          thursday: "00:00-00:00",
          friday: "00:00-00:00",
          saturday: "00:00-00:00",
          sunday: "00:00-00:00",
        },
        id: uid + "1",
        link: "",
        name: this.state.title,
        number: this.state.number,
        email: firebase.auth().currentUser.email,
        facebook: "",
        instagram: "",
        food: false,
        student: false,
        created: new Date(),
        trial: true,
        subscription: 0,
      });
      ref = firebase.firestore().collection("owners").doc(uid);
      ref.update({
        bars: [uid + "1"],
      });
      this.props.history.push("/dashboard");
    } else {
      this.setState({ errorText: "Everything is not filled in correctly." });
    }
  }

  render() {
    const { t } = this.props;
    const options = [
      { value: "Bar", label: "Bar	" },
      { value: "Pub", label: "Pub" },
      { value: "Café", label: "Café" },
      { value: "Bistro", label: "Bistro" },
      { value: "Restaurant", label: "Restaurant" },
      { value: "Lounge", label: "Lounge" },
      { value: "Bodega", label: "Bodega" },
      { value: "Wine bar", label: "Wine bar" },
      { value: "Gastro pub", label: "Gastro pub" },
      { value: "Cocktail bar", label: "Cocktail bar" },
      { value: "Latino bar", label: "Latino bar" },
      { value: "Karaoke", label: "Karaoke" },
      { value: "Jazz bar", label: "Jazz bar" },
      { value: "Rock bar", label: "Rock bar" },
      { value: "Piano bar", label: "Piano bar" },
      { value: "Bowling", label: "Bowling" },
      { value: "Beach bar", label: "Beach bar" },
      { value: "Food truck", label: "Food truck" },
      { value: "Discothèque", label: "Discothèque" },
      { value: "Champagne bar", label: "Champagne bar" },
      { value: "LGBTQ+", label: "LGBTQ+" },
      { value: "Gentlemens bar", label: "Gentlemens bar" },
      { value: "Ladies bar", label: "Ladies bar" },
      { value: "Libertine", label: "Libertine" },
      { value: "Pool tables", label: "Pool tables" },
      { value: "Game bar", label: "Game bar" },
      { value: "Distillery", label: "Distillery" },
      { value: "Brewerie", label: "Brewerie" },
      { value: "Comedy bar", label: "Comedy bar" },
      { value: "Cabaret", label: "Cabaret" },
      { value: "Hotel bar", label: "Hotel bar" },
      { value: "Casino", label: "Casino" },
      { value: "Rooftop bar", label: "Rooftop bar" },
      { value: "Sports bar", label: "Sports bar" },
      { value: "Coffee shop", label: "Coffee shop" },
      { value: "Vegetarian", label: "Vegetarian" },
    ];
    return (
      <div>
        <Helmet>
          <style>
            {
              ".css-1wa3eu0-placeholder{font-weight: 300 !important; font-size: 10pt !important; }.css-yk16xz-control{border:none !important; border-radius: 2px !important;}.geosuggest__input{color: #7E7E7E !important; font-size: 10pt !important; font-weight: 300 !important; border: none !important;}.css-1hwfws3{padding: 8px !important;}@media screen and (max-width: 1025px){.css-1wa3eu0-placeholder{font-size: 14pt !important;} .geosuggest__input{font-size: 14pt !important}}"
            }
          </style>
        </Helmet>
        <div className="innerReg">
          <img className="logoOnBoarding regLogo" src={logo} alt="logo"></img>
          <p className="regTitle">{t("regBar.regBar")}</p>
          <div className="">
            <input
              className="onBoardingInput"
              value={this.state.title}
              onChange={(event) => this.setState({ title: event.target.value })}
              placeholder={t("regBar.nameBar")}
            ></input>
            <Select
              isMulti
              placeholder={t("regBar.barCat")}
              className="categorySelectOnBoarding"
              value={this.state.selectedCat}
              options={options}
              onChange={(selected) => {
                this.setState({ selectedCat: selected });
              }}
            />
            <Geosuggest
              placeholder={t("regBar.searchPlaces")}
              onSuggestSelect={(suggest) => this.getLocation(suggest)}
            />
            <input
              className="onBoardingInput locationMargin"
              value={this.state.number}
              onChange={(event) =>
                this.setState({ number: event.target.value })
              }
              placeholder={t("regBar.telNumber")}
            ></input>
            <p className="errorText">{this.state.errorText}</p>
          </div>
          <button className="buttonOnBoarding" onClick={() => this.addBar()}>
            {t("regBar.next")}
          </button>
        </div>
      </div>
    );
  }
}

export default withTranslation()(RegBar);
